/**
 * reader/Unavailable — rendered by ReaderController#render_web_content_unavailable
 * (TASK-009 Phase 2/5) whenever the current release's `web_content_status` is
 * not `"ready"` (still `pending` ingest, or marked `invalid` — see
 * IngestReleaseJob). The manual's bundle may still be perfectly usable on
 * mobile (which reads the ActiveStorage bundle directly, unaffected by this
 * status) — this page only says the WEB reader can't serve it right now.
 */
import Heading from '@arianna/design-system/Heading'
import Text from '@arianna/design-system/Text'
import Button from '@arianna/design-system/Button'

interface Props {
  manualVersionId: number
  manualTitle: string
  webContentStatus: 'pending' | 'invalid' | string
}

function copyFor(status: string): { heading: string; body: string } {
  if (status === 'invalid') {
    return {
      heading: 'Non disponibile su web',
      body: 'Il materiale di questo manuale non è compatibile con il reader web. Riprova più tardi o contatta chi gestisce il corso — il contenuto resta comunque disponibile sull’app.',
    }
  }
  return {
    heading: 'Preparazione in corso',
    body: 'Stiamo ancora elaborando questo manuale per la lettura da browser. Riprova tra qualche minuto.',
  }
}

export default function Unavailable({ manualTitle, webContentStatus }: Props) {
  const { heading, body } = copyFor(webContentStatus)

  return (
    <div
      style={{
        height: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg)',
        padding: 'var(--space-6)',
        fontFamily: 'var(--font-sans)',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          fontFamily: 'var(--font-mono)',
          fontSize: 13,
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          color: 'var(--ink-4)',
          marginBottom: 'var(--space-3)',
        }}
      >
        {manualTitle}
      </div>
      <Heading variant="h2" style={{ color: 'var(--ink)', marginBottom: 'var(--space-3)' }}>
        {heading}
      </Heading>
      <Text
        variant="body"
        style={{ color: 'var(--ink-3)', marginBottom: 'var(--space-6)', maxWidth: 480 }}
      >
        {body}
      </Text>
      <Button as="a" href="/library" variant="ghost" size="md">
        ← Torna alla libreria
      </Button>
    </div>
  )
}
